<template>

      <div class="relative w-full sm:w-48 border-solid border border-packageborder rounded-lg px-4 pt-5 pb-0 text-center package-type">
        <ColourCircle class="absolute color-shadow" className="dot" :colour-code="access.colour"></ColourCircle>
        <div class="text-175 font-semibold">{{ access.type }}</div>
        <div class="package-desc text-xl font-futura">{{access.desc}}</div>
        <div
          class="h-16 flex sm:justify-center justify-end"
          v-for="(term, index) in terms"
          v-bind:key="index">
          <img v-if="access.contents.includes(term.tid)" class="self-center" src="@/assets/checkgreen.svg"/>
        </div>
      </div>
</template>

<script>
    import ColourCircle from "@/components/ColourCircle";
    export default {
        name: "PackageType",
        components: { ColourCircle },
        props: {
            access: {
                type: Object,
                default: function() {
                    return {}
                }
            },
            terms: {
                type: Array,
                default: function() {
                    return []
                }
            }
        }
    }
</script>

<style scoped>

  .package-desc {
    padding-bottom: 20px;
    height: 200px;
    overflow: hidden;
  }

  .package-type-wrapper {
    top: -200px;
    pointer-events: none;
  }

  .color-shadow {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.23);
  }

  .library-link {
      pointer-events: all;
  }

  @media (max-width: 691px) {
    .package-type {
      border-bottom: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
</style>
